<template>
    <div>
        <div v-if="reportLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

    <div v-if="reportFound === false && reportLoading === false">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">Sorry...</h2>
            </div>
        </div>
        <div class="widget">
            <div class="widget-body">
                <p>The report could not be found. Please check the URL and try again.</p>
                <p> <router-link to="/">Return Home</router-link></p>
            </div>
        </div>
    </div>
    <div v-if="fireStoppingReport">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">
                    <router-link to="/fire-stopping-reports">
                        Fire Stopping Reports</router-link>
                    &raquo;
                    {{ fireStoppingReport.job_number }} | {{ fireStoppingReport.prepared_for }}        </h2>
            </div>
            <div class="col-md-4">
                <router-link :to="{ name: 'fire-stopping-report-edit', params: {id: fireStoppingReport.site_fire_stopping_report_id} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Report
                </router-link>
            </div>
        </div>

        <div class="widget">
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td><strong>Sequential Reference Number</strong></td>
                            <td>{{ fireStoppingReport.sequential_reference_number }}</td>
                        </tr>
                        <tr>
                            <td><strong>Job Number</strong></td>
                            <td>{{ fireStoppingReport.job_number }}</td>
                        </tr>
                        <tr>
                            <td><strong>Prepared for</strong></td>
                            <td>{{ fireStoppingReport.prepared_for }}</td>
                        </tr>
                        <tr>
                            <td><strong>Site Address</strong></td>
                            <td>{{ fireStoppingReport.site_address }}</td>
                        </tr>
                        <tr>
                            <td><strong>Date of Inspection</strong></td>
                            <td>{{ fireStoppingReport.date_of_inspection | formatDate }}</td>
                        </tr>
                        <tr v-if="fireStoppingReport.offline_sign_off_signature_image == null || fireStoppingReport.offline_sign_off_signature_image == undefined">
                            <td><strong>Sign-off Signature</strong></td>
                            <td>
                                <span v-if="fireStoppingReport.sign_off_signature_image == null || fireStoppingReport.sign_off_signature_image == undefined">No signature found</span>
                                <span v-else>Uploaded</span>
                            </td>
                        </tr>
                        <tr v-else>
                            <td><strong>Sign-off Signature (offline)</strong></td>
                            <td>
                                <img class="img-fluid" v-bind:src="fireStoppingReport.offline_sign_off_signature_image.data">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Site Plans</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="fireStoppingReportSitePlans && fireStoppingReportSitePlans.length > 0">
                                    <fsr-site-plan-line
                                            v-for="item in fireStoppingReportSitePlans"
                                            v-bind:key="item.site_fire_stopping_report_site_plan_id"
                                            v-bind:item="item"
                                            @site-plan-removed="removeSitePlanAndIssues"
                                    ></fsr-site-plan-line>
                                </table>
                                <p class="text-center" v-else>There are no site plans attached to this report.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'fire-stopping-report-add-site-plan', params: {id: fireStoppingReport.site_fire_stopping_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Site Plan
                        </router-link>

                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Issues</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="fireStoppingReportItems && fireStoppingReportItems.length > 0">
                                    <fsr-issue-line
                                            v-for="item in fireStoppingReportItems"
                                            v-bind:key="item.site_fire_stopping_report_item_id"
                                            v-bind:issue="item"
                                            v-bind:fireStoppingReport="fireStoppingReport"
                                    ></fsr-issue-line>
                                </table>
                                <p class="text-center" v-else>There are no issues attached to this report.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'fire-stopping-report-add-item', params: {id: fireStoppingReport.site_fire_stopping_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Issue
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import FsrIssueLine from '@/components/FsrIssueLine.vue';
    import FsrSitePlanLine from '@/components/FsrSitePlanLine.vue';

    export default {
        components: {
            FsrIssueLine,
            FsrSitePlanLine
        },
        data() {
            return {
                reportFound: false,
                reportLoading: true,
                fireStoppingReport: null,
                fireStoppingReportSitePlans: [],
                fireStoppingReportItems: [],
            }
        },
        methods: {
            getFireStoppingReport() {
                var vmt = this;
                this.getDb(function onConnected(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_reports').objectStore('fire_stopping_reports');
                        var storeRequest = objectStore.get(reportId);


                        storeRequest.onsuccess = function(event) {
                            vm.fireStoppingReport = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.reportFound = true;
                            }
                            vm.reportLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.reportFound = false;
                            vm.reportLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getReportSitePlans() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.fireStoppingReportSitePlans = [];
                    
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_report_site_plans').objectStore('fire_stopping_report_site_plans');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (
                                        vm.fireStoppingReportSitePlans && reportId == cursor.value.site_fire_stopping_report_id
                                        && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.fireStoppingReportSitePlans.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getReportItems() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.fireStoppingReportItems = [];
                    
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_report_items').objectStore('fire_stopping_report_items');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (
                                        vm.fireStoppingReportItems && reportId == cursor.value.site_fire_stopping_report_id
                                        && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.fireStoppingReportItems.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            removeSitePlanAndIssues(site_plan_id) {
                let sitePlanIndex = this.fireStoppingReportSitePlans.findIndex(i => i.site_fire_stopping_report_site_plan_id == site_plan_id);
                if(sitePlanIndex >= 0) {
                    this.fireStoppingReportSitePlans.splice(sitePlanIndex, 1);
                }
                this.fireStoppingReportItems = this.fireStoppingReportItems.filter(i => i.site_fire_stopping_report_site_plan_id != site_plan_id);
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FSR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getFireStoppingReport();
            this.getReportSitePlans();
            this.getReportItems();
        }
    }
</script>